import React from "react";
import PolicyLayout from "@/components/PolicyLayout";

const TermsOfService = () => (
  <PolicyLayout
    title="Terms of Service"
    kicker="The fine print"
    intro="By using GirlyGrove, you agree to these terms and conditions."
    sections={[
      {
        heading: "Pricing & Availability",
        paragraphs: [
          "All product descriptions, pricing, and availability are subject to change without prior notice.",
          "Orders may be cancelled in cases of pricing errors, stock issues, or suspected fraudulent activity.",
        ],
      },
      {
        heading: "Product Display",
        paragraphs: [
          "Product colors may vary slightly due to screen settings and photography. We do our best to capture every piece accurately.",
        ],
      },
      {
        heading: "Policy Updates",
        paragraphs: ["GirlyGrove reserves the right to modify policies and website content at any time."],
      },
      {
        heading: "Order Information",
        paragraphs: ["Users must provide accurate and complete information while placing orders."],
      },
      {
        heading: "Jurisdiction",
        paragraphs: ["Any disputes shall be subject to the jurisdiction of Vadodara, Gujarat, India."],
      },
    ]}
  />
);

export default TermsOfService;
